import { Asset } from "contentful";
import { IOption } from "@/types/common";
import { IMetaFields } from "@/types/generated/contentful";

enum RobotsContent {
  follow = "follow",
  index = "index",
  no_follow = "nofollow",
  no_index = "noindex",
}

enum PageType {
  website = "website",
  article = "article",
}

export const defaultMetaTags: IMetaFields = {
  title: "SponsorPulse",
  description:
    "Unlock actionable insights with our revolutionary sponsorship intelligence tool, and sponsorship solutions that are built with marketers & sales people in mind.",
  pageType: PageType.website,
  shareImage: <Asset>{
    fields: {
      file: {
        url: "/shareImage.png",
      },
    },
  },
  robotsIndex: RobotsContent.index,
  robotsFollow: RobotsContent.follow,
};

export const HOME_PAGE = {
  label: "Home",
  slug: "home",
  route: "/",
};

// FORM VALIDATION
export const REQUIRED_FIELD = " is required";
export const INVALID_EMAIL = "Please enter a valid email address";

// HUBSPOT CONSTANTS
export const HUBSPOT_FORM_NOT_FOUND = "Form not found";
export const HUBSPOT_GENERIC_ERROR = "Someting went wrong";

export const METRIC_OPTIONS: IOption[] = [
  {
    value: "consideration",
    label: "Consideration",
  },
  {
    value: "engagement",
    label: "Engagement",
  },
  {
    value: "excitement",
    label: "Excitement",
  },
  {
    value: "favorability",
    label: "Favourability",
  },
  {
    value: "daily_weekly",
    label: "Intensity",
  },
  {
    value: "momentum",
    label: "Momentum",
  },
  {
    value: "opportunity_score",
    label: "Opportunity Score",
  },
  {
    value: "passion",
    label: "Passion",
  },
];

export const SKIP_REGIONS = ["ontario", "quebec"]; // skip rendering of state provinces in these regions
